import { render, staticRenderFns } from "./FbSelect.vue?vue&type=template&id=6458e37e&scoped=true"
import script from "./FbSelect.vue?vue&type=script&lang=js"
export * from "./FbSelect.vue?vue&type=script&lang=js"
import style0 from "./FbSelect.vue?vue&type=style&index=0&id=6458e37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6458e37e",
  null
  
)

export default component.exports